<div>
  <glxy-form-field appearance="outline">
    <input
      matInput
      placeholder="{{ 'INBOX.NEW_MESSAGE.PHONE_NUMBER_EMAIL_OR_CONTACT_NAME' | translate }}"
      [formControl]="control"
      name="contact"
      (input)="searchChanged()"
      autocomplete="off"
      [matAutocomplete]="auto"
      />
    <mat-autocomplete
      #auto
      [displayWith]="displayContact"
      autoActiveFirstOption
      class="search-select-autocomplete"
      (optionSelected)="onOptionSelected($event)"
      >
      @for (contact of contacts$ | async; track contact) {
        <mat-option [value]="contact" class="contact-info">
          <span class="glxy-option-text label">
            {{ displayContactInfo(contact).name }}
          </span>
          <br />
          <span class="glxy-option-text description">
            {{ displayContactInfo(contact).phoneAndEmail }}
          </span>
        </mat-option>
      }
      @if (!(contacts$ | async)?.length) {
        <mat-option [id]="'add-contact'" [value]="control?.value" class="add-contact-option">
          <mat-icon aria-hidden="false" aria-label="add contact">add</mat-icon>
          <span class="label">{{ 'INBOX.EMPTY.ADD_CONTACT' | translate }}</span>
        </mat-option>
      }
    </mat-autocomplete>

    @if (control.hasError('phone')) {
      <glxy-error>
        {{ 'INBOX.ERROR.INVALID_PHONE_NUMBER' | translate }}
      </glxy-error>
    }
    @if (control.hasError('invalidInput')) {
      <glxy-error>
        {{ 'INBOX.ERROR.INVALID_INPUT' | translate }}
      </glxy-error>
    }
    @if (control.hasError('invalidSelection')) {
      <glxy-error>
        {{ 'INBOX.ERROR.REQUIRED_FIELD' | translate }}
      </glxy-error>
    }
  </glxy-form-field>
</div>
